'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _eventemitter3 = require('eventemitter3');

var _eventemitter32 = _interopRequireDefault(_eventemitter3);

var eventEmitter = new _eventemitter32['default']();
exports['default'] = eventEmitter;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/EventEmitter.js
 ** module id = 79
 ** module chunks = 2
 **/